import { useState } from "react";
import { toast } from "sonner";
import { Star } from "lucide-react";
import api, { apiError } from "../../lib/api";

export const FeedbackPanel = ({ bookings }) => {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [message, setMessage] = useState("");
  const [bookingRef, setBookingRef] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (rating === 0) {
      toast.error("Please choose a star rating");
      return;
    }
    setBusy(true);
    try {
      const { data } = await api.post("/feedback", { rating, message, booking_ref: bookingRef || null });
      setSent(data);
      toast.success("Thank you — your feedback reached us");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  if (sent)
    return (
      <div className="bg-white rounded-2xl border border-[#E2E8F0] p-8 max-w-lg text-center" data-testid="feedback-thanks">
        <div className="flex justify-center gap-1 mb-3">
          {[1, 2, 3, 4, 5].map((s) => <Star key={s} className={`w-6 h-6 ${s <= sent.rating ? "fill-[#FFDC00] text-[#FFDC00]" : "text-[#d5ddd5]"}`} />)}
        </div>
        <h3 className="heading-upper text-lg text-[#144733]">Thank you</h3>
        <p className="text-sm text-[#57685e] mt-2">Every rating is read by the branch team it concerns. Reference {sent.feedback_id}.</p>
      </div>
    );

  return (
    <form onSubmit={submit} className="bg-white rounded-2xl border border-[#E2E8F0] p-6 max-w-lg space-y-4" data-testid="feedback-form">
      <h3 className="heading-upper text-sm tracking-widest text-[#144733]">How did we do?</h3>
      <div className="flex gap-1" data-testid="feedback-stars">
        {[1, 2, 3, 4, 5].map((s) => (
          <button key={s} type="button" onClick={() => setRating(s)} onMouseEnter={() => setHover(s)} onMouseLeave={() => setHover(0)}
            data-testid={`feedback-star-${s}`}>
            <Star className={`w-8 h-8 transition-colors ${s <= (hover || rating) ? "fill-[#FFDC00] text-[#FFDC00]" : "text-[#d5ddd5]"}`} />
          </button>
        ))}
      </div>
      {(bookings || []).length > 0 && (
        <div>
          <label className="field-label">Related booking (optional)</label>
          <select className="field-input" value={bookingRef} onChange={(e) => setBookingRef(e.target.value)} data-testid="feedback-booking-select">
            <option value="">General feedback</option>
            {bookings.map((b) => <option key={b.booking_ref} value={b.booking_ref}>{b.booking_ref} · {b.vehicle.name}</option>)}
          </select>
        </div>
      )}
      <div>
        <label className="field-label">Your words *</label>
        <textarea required rows={4} className="field-input" placeholder="What worked, what didn't — we read everything."
          value={message} onChange={(e) => setMessage(e.target.value)} data-testid="feedback-message-input" />
      </div>
      <button type="submit" disabled={busy} className="btn-cta rounded w-full py-3 text-xs" data-testid="feedback-submit-btn">
        {busy ? "Sending…" : "Send feedback"}
      </button>
    </form>
  );
};
